import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    gap: 10px;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    height: 80%;

    @media (max-width: 700px) {
        gap: 15px;
    }
`;

export const ContaintableButton = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const Table = styled.table`
    width: 100%;
    height: 100%;
    border-collapse: collapse;
    
    th:last-child,
    td:last-child{
        width: 85px;
    }

    th:nth-child(1),
    td:nth-child(1){
        width: 50px;
    }

    tr {
        display: table;
        width: 100%;
        table-layout: fixed;
        border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_50};
    }

    td,
    th {
        text-align: center;
        padding: 10px 0;
    }
    
    td > div {
        display: flex;
        justify-content: space-around;
    }
    
    & svg {
        font-size: 18px;
    }

    @media (max-width: 900px) {
        th, td {
            display: none;
        }

        th:nth-child(1),
        td:nth-child(1), /* Primeira coluna */
        th:nth-child(2),
        td:nth-child(2),
        th:last-child,
        td:last-child { /* Ultima coluna */
            display: table-cell;
        }
    }
`;

export const THead = styled.thead`
    background-color: ${(props) => props.theme.colors.gray.gray_50};
`;

export const TBody = styled.tbody`
    display: block;
    overflow-y: auto;
    width: 100%;
    height: 100%;

    &::-webkit-scrollbar { 
        display: none;
    }
`;

export const TdPopMenu = styled.td`
    text-align: center;
    position: relative;
`;

export const ContentPopMenu = styled.div`
`;

export const ButtonTable = styled.button`
    display: flex;
    justify-content: center;

    padding: 8px;
    
    border-radius: 30px;
    box-shadow: 0px 1px 4px 0px ${(props) => props.theme.colors.gray.gray_100};
    background-color: ${(props) => props.theme.colors.white};
    
    &:hover {
        background-color: ${(props) => props.theme.colors.gray.gray_100};
    }
`;

export const HighlightedField = styled.p`
    display: inline-flex;
    align-items: center;
    gap: 3px;
    background-color: ${(props) => props.theme.colors.red.red_50};
    border-radius: 4px;
    padding: 3px 5px;
    font-size: 12px;
    color: ${(props) => props.theme.colors.primary};
    border: 1px solid ${(props) => props.theme.colors.primary};
`;

export const ContentButton = styled.div`
    display: flex;
    justify-content: center;
    gap: 16px;

    padding: 4px 0px;
`;

export const ButtonLink = styled.button`
    background-color: transparent;
    text-decoration: underline;
    color: ${(props) => props.theme.colors.blue};
    
    &:hover{
        color: ${(props) => props.theme.colors.primary};
    }
`;

export const ContentItems = styled.div<{ isFill: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    width: 100%;
    
    padding: ${(props) => props.isFill ? '12px 8px' : '0px'};
    border-radius: 4px;
    
    background-color: ${(props) => props.isFill ? props.theme.colors.gray.gray_50 : props.theme.colors.white};
    
    @media (max-width: 900px) {
        height: ${(props) => props.isFill ? '20%' : '100%'};
        overflow-x: scroll;
    }
`;

export const ButtonFilter = styled.button`
    background-color: aqua;
`;